import React from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
    BooleanInput,
    required,
    useNotify,
    useRefresh,
    useRedirect,
} from 'react-admin';

const DocumentTypeEdit = (props: any) => {
    const notify = useNotify();
    const refresh = useRefresh();
    const redirect = useRedirect();

    const onSuccess = () => {
        notify('Document type updated successfully', { type: 'success' });
        redirect('/document-types');
        refresh();
    };

    const onFailure = (error: any) => {
        notify(`Error: ${error?.message || 'Failed to update document type'}`, {
            type: 'error',
        });
    };

    return (
        <Edit
            {...props}
            undoable={false}
            mutationMode="pessimistic"
            onSuccess={onSuccess}
            onFailure={onFailure}
        >
            <SimpleForm>
                <TextInput source="name" validate={required()} />
                <TextInput source="code" validate={required()} />
                <TextInput source="description" multiline rows={3} />
                <BooleanInput source="isActive" label="Active" />
            </SimpleForm>
        </Edit>
    );
};

export default DocumentTypeEdit;
